import React, { Fragment, useSyncExternalStore } from 'react';
import { sessionEpoch, subscribeSession } from './session';

// Remount the entire private shell, not just its data: dialogs, cached identity,
// selections and guarded async callbacks must belong to one account session.
export const SessionBoundary = ({ children }) => {
  const epoch = useSyncExternalStore(subscribeSession, sessionEpoch);
  return <Fragment key={epoch}>{children}</Fragment>;
};